export default __webpack_public_path__ + "static/media/Competition.09baf9f6.svg";